import { Redirect, useParams } from "react-router-dom";

import DataLoader from "@/components/DataLoader";
import { TestProductOptionProvider } from "@/contexts/TestProductOptionContext";
import { ERROR_404_URL } from "@/core/urls";
import { CONSUMER_TEST_PRODUCT_DETAIL_PAGE_QUERY, CONSUMER_TEST_PRODUCT_OPTION_FIELDS } from "@/graphql/shop";

import B2CHeader from "../header/B2CHeader";
import Full from "./testProductDetail/page/Full";
import Truncated from "./testProductDetail/page/Truncated";
import showFullDetails from "./testProductDetail/utils/showFullDetails";

export const TRUNCATED_TEST_PRODUCT_VIEW_BG = "haze";
export const FULL_TEST_PRODUCT_VIEW_BG = "haze";

export function TestProductDetail({ testProduct }) {
  let content = null;

  const fullView = showFullDetails(testProduct);

  if (fullView) {
    content = <Full testProduct={testProduct} />;
  } else {
    content = <Truncated testProduct={testProduct} />;
  }

  return (
    <>
      {content}
    </>
  );
}

export default function TestProductDetailPage() {
  const { slug } = useParams();

  return (
    <DataLoader
      query={CONSUMER_TEST_PRODUCT_DETAIL_PAGE_QUERY}
      variables={{
        currency: "GBP",
        slug
      }}
      render={({ consumerTestProduct: testProduct }) =>
        testProduct ? (
          <>
            <B2CHeader />
            <TestProductOptionProvider
              testProductOptionFragment={CONSUMER_TEST_PRODUCT_OPTION_FIELDS}
              testProductOptionFragmentName="ConsumerTestProductOptionFields"
              testProductOptionFragmentType="TestProductOptionType"
            >
              <TestProductDetail testProduct={testProduct} />
            </TestProductOptionProvider>
          </>
        ) : (
          <Redirect to={ERROR_404_URL} />
        )
      }
    />
  );
}
